import Image from '@dustin-web/microsite-components/src/image'

type Props = {
  linkBoxes: {
    openInNewWindow: boolean
    url: string
    text: string
    alternativeImageUrl?: string | null
    image?: { url: string; relativeUrl: string } | null
  }[]
}

export const GenericLinkBoxes = ({ linkBoxes }: Props) => {
  return (
    <div className="row sm-gutters">
      {linkBoxes.map(linkBox => {
        const targetProps = linkBox.openInNewWindow
          ? {
              target: '_blank',
              rel: 'noreferrer',
            }
          : {}

        const imageUrl =
          linkBox.image?.relativeUrl ??
          linkBox.alternativeImageUrl
            ?.replace('http://dustinweb.azureedge.net', '')
            .replace('https://dustinweb.azureedge.net', '')
            .replace('//dustinweb.azureedge.net', '')

        return (
          <div key={linkBox.url} className="col-12 col-sm-6 col-md-4 u-mb-16">
            <a
              className="c-box d-flex flex-column align-items-center u-decoration-none"
              href={linkBox.url}
              {...targetProps}>
              {imageUrl && (
                <Image
                  className="u-pb-8"
                  src={imageUrl}
                  alt={linkBox.text}
                  width="160"
                  height="80"
                />
              )}
              <span>{linkBox.text}</span>
            </a>
          </div>
        )
      })}
    </div>
  )
}
